// extracted by mini-css-extract-plugin
module.exports = {"popup":"styles_popup__vh6kF","container":"styles_container__7J1tp","inverted":"styles_inverted__aOQKQ"};